export const FormsMembersTypesEnum = {
  Teams: {
    key: 1,
    value: 'teams',
  },
  Employees: {
    key: 2,
    value: 'employees',
  },
  Users: {
    key: 3,
    value: 'users',
  },
  Positions: {
    key: 4,
    value: 'positions',
  },
  Candidates: {
    key: 5,
    value: 'candidates',
  },
};
